export default __webpack_public_path__ + "static/media/about-3.63c5005e.jpg";